import { render } from "./DashboardSpaceProductsAndSolutions.vue?vue&type=template&id=7317258a&scoped=true"
import script from "./DashboardSpaceProductsAndSolutions.vue?vue&type=script&lang=js"
export * from "./DashboardSpaceProductsAndSolutions.vue?vue&type=script&lang=js"

import "./DashboardSpaceProductsAndSolutions.vue?vue&type=style&index=0&id=7317258a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7317258a"

export default script